import React from 'react'

type TitleHighlightProps = React.PropsWithChildren

export const TitleHighlight = ({ children }: TitleHighlightProps) => {
  if (!children) return null

  return (
    <span className="px-2 rounded text-lama-yellow bg-lama-yellow/20">
      {children}
    </span>
  )
}
